export let displayedColumns: string[] = [
  'name',
  'district',
  'municipality',
  'area',
  'basin',
  'underbasin',
  'last',
  'max',
  'min',
];

export let displayedNames: any = {
  name: 'Nome',
  district: 'Provincia',
  municipality: 'Comune',
  area: 'Zona',
  basin: 'Bacino',
  underbasin: "Corso d'acqua",
  last: 'Ultimo',
  max: 'Max',
  min: 'Min',
};
